import React from 'react';
import { getLocationParam } from '@core/js/utils/url.util';
import { CookiesRegulationMessage as CookiesRegulationMessageCore } from '@core/js/components/main/CookiesRegulationMessage/CookiesRegulationMessage';

// #region @theme
export const CookiesRegulationMessage = (props) => {
    const isHideHeader = getLocationParam('hideHeader') === '1';
    const isHideFooter = getLocationParam('hideFooter') === '1';

    return isHideHeader && isHideFooter ? null : <CookiesRegulationMessageCore {...props} />;
};
// #endregion
